import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-card-suporte-menu',
    standalone: true,
    imports: [MatButton, MatCard, MatCardContent, TranslocoPipe],
    templateUrl: './card-suporte-menu.component.html',
    styleUrl: './card-suporte-menu.component.scss',
})
export class CardSuporteMenuComponent {
    @Input() isCollapsed = false;

    constructor() {}

    openLinkZap(): void {
        // Abrir link do WhatsApp para suporte
        window.open('https://links.ratoeirads.com/suporte', '_blank');
    }
}
